import './Variants.16223161678404c9235f9d3ec94332ea.css';
export default {"primary":"_primary_147r2_1","error":"_error_147r2_1","secondary":"_secondary_147r2_1","tertiary":"_tertiary_147r2_1","process":"_process_147r2_1"};